import styled from 'styled-components';

export const PopupContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    position: absolute;
    bottom: 150%;
    left: -75px;
    z-index: 1000000;
`;

export const PopupBody = styled.div`
    background-color: #fff;
    width: 200px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    padding: 12px;
    border-radius: 10px;
`;

export const PopupBottom = styled.div`
    width: 15px;
    height: 15px;
    border-top: solid 15px #fff;
    border-left: solid 15px transparent;
    border-right: solid 15px transparent;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Popups/MembersPopups/style.js